import { render, staticRenderFns } from "./DialogTextArea.vue?vue&type=template&id=1e91bf17&"
import script from "./DialogTextArea.vue?vue&type=script&lang=js&"
export * from "./DialogTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports